Namespace 'Customer.Filters.Ticket'

class Customer.Filters.Ticket.StatusFilterView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/ticket/status_filter']
  className: 'checkboxes filter-field-container status-filter mw-100 d-flex'
  attributes:
    'hide-if-empty': 'status'

  initialize: ({statuses, query}) ->
    @statuses = statuses
    @query = query

  render: ->
    @$el.html @template
      statuses: @statuses
      query: @query
    @
